(() => {
  if (window.tcsCollectionPills) return;
  window.tcsCollectionPills = true;

  const initialize = (root = document) => {
    root.querySelectorAll('[data-collection-pill-browser]').forEach((browser) => {
      if (browser.dataset.ready) return;
      browser.dataset.ready = 'true';
      const row = browser.querySelector('[data-collection-pill-row]');
      let frame;
      const update = () => {
        if (!browser.isConnected) { observer.disconnect(); return; }
        const scrollable = browser.dataset.mobileScroll !== 'false' && window.matchMedia('(max-width: 749px)').matches && row.scrollWidth > row.clientWidth + 1;
        browser.dataset.overflowEnd = String(scrollable && row.scrollWidth - row.clientWidth - Math.abs(row.scrollLeft) > 2);
        if (scrollable) row.setAttribute('tabindex', '0');
        else row.removeAttribute('tabindex');
      };
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
      const observer = new ResizeObserver(schedule);
      observer.observe(browser);
      row.addEventListener('scroll', schedule, { passive: true });
      row.addEventListener('focusin', (event) => {
        const link = event.target.closest('a');
        if (link && window.matchMedia('(max-width: 749px)').matches) {
          link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }
      });
      document.fonts.ready.then(schedule);
      schedule();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
